module.exports = __webpack_public_path__ + "img/speaker-2-2.ca4a889d.jpg";